

var _squid = require('squid');

var _logger = require('xo-beaver/dist/logger');

var _angular = require('angular');

var _index = require('xo-models/src/consent/index');

var getNoticeAndConsentUserAgreementParameters = function getNoticeAndConsentUserAgreementParameters() {
    return {
        action: 'evalPolicy',
        params: {
            flow: 'CHECKOUT',
            policyType: 'UserLegalConsent'
        }
    };
};

(function exportProviders(angular) {
    angular && angular.exportProviders(module, exports, __dirname, __filename);
})(window.angular);

angular.module().factory('$GatherActiveConsentFactory', function () {
    var state = {};

    var userAgreementConsentModel = _index.$UserAgreementConsentModel.instance(_angular.$rootScope.token);

    var getUserAgreementUrl = function getUserAgreementUrl() {
        return state.upcomingUrl;
    };
    var getUserAgreementVersions = function getUserAgreementVersions() {
        var _state = state,
            majorVersion = _state.majorVersion,
            minorVersion = _state.minorVersion;


        return { majorVersion: majorVersion, minorVersion: minorVersion };
    };

    var isConsentRequired = function isConsentRequired() {
        return state.enabled && state.status === 'PENDING';
    };
    var clearState = function clearState() {
        state = {};
    };

    var gatherActiveConsentExp = function gatherActiveConsentExp() {
        return (0, _squid.$elmo)('xo::gatheractiveconsent', {
            'ctx.COUNTRY': _squid.$locale.country,
            'ctx.app_name': 'hermesnodeweb'
        }, 'Trmt_FEATURE_GATHER_ACTIVE_CONSENT').then(function (result) {
            var treatmentEnabled = Boolean(result && result.treatment_name);

            if (treatmentEnabled) {
                _logger.$logger.info('gatherActiveConsentExp_' + result.treatment_name);
            } else {
                _logger.$logger.info('gatherActiveConsentExp_Ctrl');
            }

            return {
                enabled: treatmentEnabled
            };
        });
    };

    var decideEligibility = function decideEligibility() {
        // Data already fetched, just resolve because state should be already populated
        if (userAgreementConsentModel.meta && userAgreementConsentModel.meta.populated) {
            return _squid.$promise.resolve({});
        }

        return gatherActiveConsentExp().then(function (_ref) {
            var enabled = _ref.enabled;

            state.enabled = enabled;

            if (!enabled) {
                return _squid.$promise.resolve();
            }

            return userAgreementConsentModel.retrieve(getNoticeAndConsentUserAgreementParameters()).then(function (consentData) {
                state.upcomingUrl = consentData.getUpcomingUrl();
                state.majorVersion = consentData.getMajorVersion();
                state.minorVersion = consentData.getMinorVersion();
                state.status = consentData.getStatus();

                _logger.$logger.info('gatherActiveConsentData_fetched', state);
            });
        })['catch'](function (err) {
            // If some error happens, we stick to default data
            _logger.$logger.error('gatherActiveConsent_error', err);
        });
    };

    var recordConsent = function recordConsent() {
        if (!isConsentRequired()) {
            return;
        }

        return userAgreementConsentModel.action('recordConsent', {
            data: {
                policyType: 'UserLegalConsent',
                consentValues: {
                    version: state.majorVersion + '.' + state.minorVersion
                }
            }
        });
    };

    return {
        getUserAgreementUrl: getUserAgreementUrl,
        getUserAgreementVersions: getUserAgreementVersions,
        isConsentRequired: isConsentRequired,
        clearState: clearState,
        decideEligibility: decideEligibility,
        recordConsent: recordConsent
    };
});

_squid.$elmo;

_squid.$locale;

_squid.$promise;

_logger.$logger;

_angular.$rootScope;

_index.$UserAgreementConsentModel;


//////////////////
// WEBPACK FOOTER
// ./pages/xo-review/gatherActiveConsent.factory.js
// module id = ./pages/xo-review/gatherActiveConsent.factory.js
// module chunks = main-code-split